// @ts-nocheck

import React, { Component, memo } from 'react';
import { ExclamationMarkTriangleIcon, TextStyle, TicketMobileIcon } from '@ticketmaster/global-design-system';
import { withTranslation } from 'react-i18next';

import styles from './desktop.module.scss';
import { RootContext, StateContext } from '@/root/root.provider';
import { redeemTickets } from '../wallet/envelope/envelope.service';
import walletBannerOpts from '../wallet/wallet.banners';
import { getRedemptionReasonByCode, RedemptionDisabledReasons } from '../wallet/manage/redemption/redemptionDisabledReasons';
import Spinner from '../partials/spinner/spinner';
import { T } from '../helpers/i18n';
import { MultiEventEnvelopeModel } from '@/v2/models/multiEventEnvelopeModel.ts';

type Props = {
  envelope: MultiEventEnvelopeModel;
  err: any;
} & T;

type State = {
  loading: boolean;
  redirection: boolean;
  title: string;
  text: string;
  icon: object;
};

class Desktop extends Component<Props, State> {
  static contextType: React.Context<StateContext> = RootContext;

  state: State = {
    loading: true,
    redirection: false,
    title: 'DESKTOP.TITLE',
    text: 'DESKTOP.TEXT',
    icon: TicketMobileIcon
  };

  async componentDidMount() {
    const { err, envelope } = this.props;

    if (envelope?.redirectToRedemptionOnDesktop) {
      if (envelope.redemptionAvailability?.redemptionDisabled
          && envelope.redemptionAvailability.reason !== RedemptionDisabledReasons.FORCED) {
        let error = walletBannerOpts.redemptionError(getRedemptionReasonByCode(envelope.redemptionAvailability.reason));
        this.setState({ title: error.heading, text: error.content, icon: ExclamationMarkTriangleIcon });
      } else if (!envelope.redemptionAvailability?.redemptionDisabled) {
        let error = await redeemTickets(envelope.activeToken);
        if (error) {
          this.setState({ title: error.heading, text: error.content, icon: ExclamationMarkTriangleIcon });
        } else {
          this.setState({ redirection: true });
        }
      }
    }

    if (err?.validate?.status === 'alreadyRedeemed') {
      window.location.href = err.validate.tmOrdersUrl;
      this.setState({ redirection: true });
    }

    this.setState({ loading: false });
  }

  render() {
    const { t } = this.props;

    const formatHeaderValue = (value: object | string) => {
      return value?.toUpperCase().replace(/\.$/, "");
    };

    return (
      <div>
        <Spinner isShown={this.state.loading || this.state.redirection}/>
        {!this.state.loading && !this.state.redirection &&
          (
            <div className={styles.desktop}>
              <this.state.icon size="4em"></this.state.icon>
              <TextStyle.Fiji className={styles.headingText}>{formatHeaderValue(t(this.state.title))}</TextStyle.Fiji>
              <TextStyle.Rainier className={styles.mainText}>{t(this.state.text)}</TextStyle.Rainier>
            </div>
          )}
      </div>
    );
  }
}

export default withTranslation('translation')(memo(Desktop));
